import { userLabel } from '@app/pcs/models/user-label';
import { gql } from 'apollo-angular';

export const addLabel = 'addLabel';
export const addLabelMutation = gql`
  mutation addLabel($labelId: Long!, $dossierIds: [Long]!) {
    addLabel (labelId: $labelId, dossierIds: $dossierIds) {
      ...userLabel
    }
  }
  ${userLabel}
`;

export const removeLabelFromDossiers = 'removeLabelFromDossiers';
export const removeLabelFromDossiersMutation = gql`
  mutation removeLabelFromDossiers($labelId: Long!, $dossierIds: [Long]!) {
    removeLabelFromDossiers (labelId: $labelId, dossierIds: $dossierIds) {
      ...userLabel
    }
  }
  ${userLabel}
`;

export const createLabel = 'createLabel';
export const createLabelMutation = gql`
  mutation createLabel($labelName: String!, $dossierIds: [Long]!) {
    createLabel (labelName: $labelName, dossierIds: $dossierIds) {
      ...userLabel
    }
  }
  ${userLabel}
`;

export const removeLabel = 'removeLabel';
export const removeLabelMutation = gql`
  mutation removeLabel($labelId: Long!) {
    removeLabel(labelId: $labelId)
  }
`;

export const shareLabelResult = 'shareLabel';
export const shareLabelMutation = gql`
  mutation shareLabel($labelId: Long!, $sharedUsers: [Long]!) {
    shareLabel(labelId: $labelId, sharedUsers: $sharedUsers)
  }
`;

export const saveLabelMutation = gql`
  mutation saveLabel($label: UserLabelInput!) {
      saveLabel(userLabel: $label) {
            ...userLabel
        }
    }
  ${userLabel}
`;
